<template>
    <f7-app :params="f7Params">
        <f7-panel left reveal>
            <f7-view url="/panel-left/" links-view=".view-main"></f7-view>
        </f7-panel>
        <f7-view url="/" :animate="false" :main="true" :iosSwipeBack="false" :pushState="false" class="safe-areas" :master-detail-breakpoint="800"></f7-view>
    </f7-app>
</template>
<script>
import routes from './routes';

export default {
    data(){
        return {
            f7Params: {
                id: 'com.vnww.kiot',
                name: 'KT SỐ',
                theme: 'ios',
                routes,
                touch:{
                    tapHold: true
                },
                dialog: {
                    buttonOk: 'Đồng ý',
                    buttonCancel: 'Hủy',
                    preloaderTitle: 'Đang xử lý...',
                    progressTitle: 'Đang xử lý...'
                }
            },
        };
    },
    created(){
        this.$store.dispatch('getMe');
    }
}
</script>
